<div class="h-screen relative overflow-hidden flex flex-col justify-between bg-[#f5f5f7] dark:bg-[#050505] text-slate-900 dark:text-gray-100 transition-colors duration-500 text-[14px] leading-normal antialiased selection:bg-indigo-500/30">

  <!-- Navigation -->
  <nav class="fixed top-0 w-full z-50 bg-[#f5f5f7]/90 dark:bg-[#0a0a0a]/80 backdrop-blur-xl border-b border-gray-200 dark:border-white/5 transition-all duration-300">
    <div class="w-full px-6 h-[64px] flex items-center justify-between">
      <div class="flex items-center gap-4 group">
        <div class="w-8 h-8 rounded-lg bg-slate-900 dark:bg-white text-white dark:text-black flex items-center justify-center shadow-sm">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6.429 9.75 2.25 12l4.179 2.25m0-4.5 5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0 4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0-5.571 3-5.571-3" />
          </svg>
        </div>
        <div class="flex items-center gap-3">
          <span class="text-gray-300 dark:text-gray-700 font-light text-xl">/</span>
          <span class="font-sans font-medium text-[15px] tracking-tight text-slate-900 dark:text-white">Question Details</span>
        </div>
      </div>
      
      <div class="flex items-center gap-6">
        <!-- Theme Toggles -->
        <div class="flex items-center p-1 rounded-full bg-gray-100/80 dark:bg-white/5 border border-gray-200/50 dark:border-white/5 backdrop-blur-md">
          <button (click)="setTheme('light')" [ngClass]="{'text-indigo-600 bg-white shadow-sm': currentTheme === 'light'}" class="p-1.5 rounded-full text-gray-400 hover:text-gray-900 dark:hover:text-white transition-all duration-200 hover:bg-white dark:hover:bg-white/10">
            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" />
            </svg>
          </button>
          <button (click)="setTheme('dark')" [ngClass]="{'shadow-sm': currentTheme === 'dark'}" class="p-1.5 rounded-full text-gray-400 hover:text-gray-900 dark:hover:text-white transition-all duration-200 hover:bg-white dark:hover:bg-white/10">
            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z" />
            </svg>
          </button>
        </div>

        <div class="hidden md:flex items-center gap-6">
          <a routerLink="/analysis-report" class="text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 font-medium text-[13px] transition-colors">
            Photo QC Analysis
          </a>
          <button (click)="goToDocumentation()" class="text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 font-medium text-[13px] transition-colors cursor-pointer">
            Documentation
          </button>
        </div>
      </div>
    </div>
  </nav>

  <!-- Main Content -->
  <main class="relative z-10 pt-[64px] w-full h-full flex flex-col flex-grow overflow-hidden transition-colors duration-500">
    
    <div class="w-full max-w-7xl fade-in mx-auto h-full overflow-y-auto hide-scroll pb-24 px-8 pt-10">
      
      <!-- Breadcrumb Navigation -->
      <nav class="flex items-center gap-2 text-sm mb-6">
        <a routerLink="/analysis-report" class="text-gray-400 dark:text-gray-500 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">
          Photo QC Analysis
        </a>
        <svg class="w-4 h-4 text-gray-300 dark:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
        </svg>
        <button (click)="goBack()" class="text-gray-400 dark:text-gray-500 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">
          Questions
        </button>
        <svg class="w-4 h-4 text-gray-300 dark:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
        </svg>
        <span class="text-gray-700 dark:text-gray-300 font-medium">Details</span>
      </nav>

      <!-- Stats Cards Row -->
      <div class="flex flex-wrap gap-3 mb-6">
        <!-- Total Locations Card - Purple -->
        <div class="bg-gradient-to-br from-violet-500 to-purple-600 rounded-xl p-4 min-w-[140px] shadow-md shadow-violet-500/20 relative overflow-hidden flex-1">
          <div class="flex items-start justify-between mb-2">
            <p class="text-white/90 font-medium text-xs">Total Locations</p>
            <div class="flex items-center gap-1 text-white/70 text-[10px]">
              <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
              </svg>
              <span>All</span>
            </div>
          </div>
          <p class="text-2xl font-bold text-white mb-2">{{ locationCount }}</p>
          <div class="flex items-end justify-between">
            <span class="text-white/60 text-[10px]">See all</span>
            <div class="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center">
              <svg class="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
              </svg>
            </div>
          </div>
        </div>

        <!-- High Confidence Card - Green -->
        <div class="bg-gradient-to-br from-emerald-400 to-green-500 rounded-xl p-4 min-w-[140px] shadow-md shadow-emerald-500/20 relative overflow-hidden flex-1">
          <div class="flex items-start justify-between mb-2">
            <p class="text-white/90 font-medium text-xs">High</p>
            <div class="flex items-center gap-1 text-white/70 text-[10px]">
              <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 18 9 11.25l4.306 4.306a11.95 11.95 0 0 1 5.814-5.518l2.74-1.22m0 0-5.94-2.281m5.94 2.28-2.28 5.941" />
              </svg>
              <span>≥85%</span>
            </div>
          </div>
          <p class="text-2xl font-bold text-white mb-2">{{ highConfidenceCount }}</p>
          <div class="flex items-end justify-between">
            <span class="text-white/60 text-[10px]">See all</span>
            <div class="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center">
              <svg class="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>
            </div>
          </div>
        </div>

        <!-- Medium Confidence Card - Orange -->
        <div class="bg-gradient-to-br from-amber-400 to-orange-500 rounded-xl p-4 min-w-[140px] shadow-md shadow-amber-500/20 relative overflow-hidden flex-1">
          <div class="flex items-start justify-between mb-2">
            <p class="text-white/90 font-medium text-xs">Medium</p>
            <div class="flex items-center gap-1 text-white/70 text-[10px]">
              <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14" />
              </svg>
              <span>70-84%</span>
            </div>
          </div>
          <p class="text-2xl font-bold text-white mb-2">{{ mediumConfidenceCount }}</p>
          <div class="flex items-end justify-between">
            <span class="text-white/60 text-[10px]">See all</span>
            <div class="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center">
              <svg class="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
            </div>
          </div>
        </div>

        <!-- Low Confidence Card - Red -->
        <div class="bg-gradient-to-br from-rose-400 to-red-500 rounded-xl p-4 min-w-[140px] shadow-md shadow-red-500/20 relative overflow-hidden flex-1">
          <div class="flex items-start justify-between mb-2">
            <p class="text-white/90 font-medium text-xs">Low</p>
            <div class="flex items-center gap-1 text-white/70 text-[10px]">
              <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6 9 12.75l4.286-4.286a11.948 11.948 0 0 1 4.306 6.43l.776 2.898m0 0 3.182-5.511m-3.182 5.51-5.511-3.181" />
              </svg>
              <span>&lt;70%</span>
            </div>
          </div>
          <p class="text-2xl font-bold text-white mb-2">{{ lowConfidenceCount }}</p>
          <div class="flex items-end justify-between">
            <span class="text-white/60 text-[10px]">See all</span>
            <div class="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center">
              <svg class="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
              </svg>
            </div>
          </div>
        </div>

        <!-- Prompts Card - Blue -->
        <div class="bg-gradient-to-br from-blue-400 to-indigo-500 rounded-xl p-4 min-w-[140px] shadow-md shadow-blue-500/20 relative overflow-hidden flex-1">
          <div class="flex items-start justify-between mb-2">
            <p class="text-white/90 font-medium text-xs">Prompts</p>
            <div class="flex items-center gap-1 text-white/70 text-[10px]">
              <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
              </svg>
              <span>Active</span>
            </div>
          </div>
          <p class="text-2xl font-bold text-white mb-2">{{ promptsCount }}</p>
          <div class="flex items-end justify-between">
            <span class="text-white/60 text-[10px]">See all</span>
            <div class="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center">
              <svg class="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <!-- Report Card -->
      <div class="bg-white dark:bg-[#0d0d0d]/80 dark:backdrop-blur-xl rounded-3xl overflow-hidden shadow-[0_8px_40px_-12px_rgba(0,0,0,0.1)] dark:shadow-[0_8px_40px_-8px_rgba(0,0,0,0.5)] border border-gray-100/80 dark:border-white/[0.06] transition-all duration-300">
        
        <!-- Header -->
        <div class="relative px-8 py-6 border-b border-gray-100/80 dark:border-white/[0.06]">
          <!-- Survey Name -->
          <h1 class="text-xl font-bold text-gray-900 dark:text-white tracking-tight mb-3">
            {{ templateName }}
          </h1>
          
          <!-- Question -->
          <p class="text-[15px] text-gray-600 dark:text-gray-400">
            <span class="font-semibold text-gray-800 dark:text-gray-200">Q{{ questionId }})</span> {{ questionName }}
          </p>
        </div>

        <!-- Search Input -->
        <div class="px-8 py-4 border-b border-gray-100/80 dark:border-white/[0.06]">
          <div class="relative max-w-md">
            <svg class="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
            </svg>
            <input 
              type="text" 
              [(ngModel)]="searchQuery"
              placeholder="Search locations or analysis..."
              class="w-full pl-11 pr-4 py-3 rounded-xl bg-gray-50 dark:bg-white/5 border border-gray-200/80 dark:border-white/10 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500/50 transition-all text-sm"
            />
          </div>
        </div>

        <!-- Loading State -->
        <div *ngIf="isLoading" class="flex flex-col items-center justify-center py-20">
          <div class="relative">
            <div class="w-14 h-14 rounded-full border-[3px] border-gray-100 dark:border-gray-800"></div>
            <div class="absolute top-0 left-0 w-14 h-14 rounded-full border-[3px] border-transparent border-t-indigo-500 animate-spin"></div>
          </div>
          <p class="mt-5 text-sm text-gray-500 dark:text-gray-400 font-medium">Loading details...</p>
        </div>

        <!-- Data Table -->
        <div *ngIf="!isLoading" class="overflow-x-auto">
          <table class="w-full">
            <thead>
              <tr class="bg-gradient-to-r from-gray-50 to-gray-50/50 dark:from-white/[0.03] dark:to-transparent">
                <th class="px-4 py-4 text-left">
                  <span class="text-[11px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-[0.08em]">
                    Location #
                  </span>
                </th>
                <th class="px-6 py-4 text-left">
                  <button (click)="toggleSort('location')" class="flex items-center gap-2 text-[11px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-[0.08em] hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">
                    Location
                    <svg *ngIf="sortColumn === 'location'" class="w-3 h-3" [class.rotate-180]="sortDirection === 'desc'" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" />
                    </svg>
                  </button>
                </th>
                <th class="px-6 py-4 text-center">
                  <button (click)="toggleSort('meetsQualityStandards')" class="flex items-center justify-center gap-2 text-[11px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-[0.08em] hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors mx-auto">
                    Quality
                    <svg *ngIf="sortColumn === 'meetsQualityStandards'" class="w-3 h-3" [class.rotate-180]="sortDirection === 'desc'" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" />
                    </svg>
                  </button>
                </th>
                <th class="px-6 py-4 text-center">
                  <button (click)="toggleSort('score')" class="flex items-center justify-center gap-2 text-[11px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-[0.08em] hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors mx-auto">
                    Confidence
                    <svg *ngIf="sortColumn === 'score'" class="w-3 h-3" [class.rotate-180]="sortDirection === 'desc'" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" />
                    </svg>
                  </button>
                </th>
                <th class="px-6 py-4 text-center">
                  <button (click)="toggleSort('analysis')" class="flex items-center justify-center gap-2 text-[11px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-[0.08em] hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors mx-auto">
                    Analysis
                    <svg *ngIf="sortColumn === 'analysis'" class="w-3 h-3" [class.rotate-180]="sortDirection === 'desc'" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" />
                    </svg>
                  </button>
                </th>
                <th class="px-6 py-4 text-center">
                  <span class="text-[11px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-[0.08em]">
                    Image
                  </span>
                </th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100/60 dark:divide-white/[0.04]">
              <tr *ngFor="let item of filteredResults; let i = index" 
                  (click)="openDetailModal(item)"
                  class="group transition-all duration-200 cursor-pointer"
                  [ngClass]="{
                    'bg-red-50/70 dark:bg-red-500/10 hover:bg-red-100/80 dark:hover:bg-red-500/15': item.score < 2,
                    'hover:bg-gradient-to-r hover:from-indigo-50/50 hover:to-transparent dark:hover:from-indigo-500/5 dark:hover:to-transparent': item.score >= 2,
                    'bg-gray-50/30 dark:bg-white/[0.01]': i % 2 === 0 && item.score >= 2
                  }">
                <td class="px-4 py-5">
                  <span class="text-sm font-mono text-gray-600 dark:text-gray-300">{{ item.locationNumber || 'N/A' }}</span>
                </td>
                <td class="px-6 py-5">
                  <div class="flex items-center gap-2">
                    <svg *ngIf="item.score < 2" class="w-5 h-5 text-red-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
                    </svg>
                    <span class="text-sm font-medium text-gray-700 dark:text-gray-200">{{ item.location }}</span>
                  </div>
                </td>
                <td class="px-6 py-5 text-center">
                  <span *ngIf="item.meetsQualityStandards" class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-emerald-50 dark:bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 text-xs font-semibold">
                    <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                    </svg>
                    Yes
                  </span>
                  <span *ngIf="!item.meetsQualityStandards" class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-red-50 dark:bg-red-500/10 text-red-600 dark:text-red-400 text-xs font-semibold">
                    <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>
                    No
                  </span>
                </td>
                <td class="px-6 py-5 text-center">
                  <div class="inline-flex items-center gap-3">
                    <div class="relative w-12 h-12">
                      <div class="w-full h-full rounded-full shadow-sm" 
                           [style.background]="currentTheme === 'dark' ? getItemDonutStyleDark(item.score) : getItemDonutStyle(item.score)">
                      </div>
                      <div class="absolute inset-[4px] rounded-full bg-white dark:bg-[#0d0d0d] flex items-center justify-center"
                           [ngClass]="{'bg-red-50 dark:bg-red-900/20': item.score < 2}">
                        <span class="text-[10px] font-bold" [style.color]="getItemScoreColor(item.score)">
                          {{ getItemConfidenceLabel(item.score) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="px-6 py-5 text-center">
                  <p class="text-sm text-gray-600 dark:text-gray-400 max-w-[200px] mx-auto truncate" [title]="item.analysis">{{ item.analysis }}</p>
                </td>
                <td class="px-6 py-5 text-center">
                  <button (click)="openDetailModal(item); $event.stopPropagation()" 
                          class="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-indigo-50 dark:bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 text-sm font-medium hover:bg-indigo-100 dark:hover:bg-indigo-500/20 transition-colors group-hover:scale-105">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                    </svg>
                    View
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          
          <!-- Empty State -->
          <div *ngIf="filteredResults.length === 0" class="flex flex-col items-center justify-center py-20 px-8">
            <div class="w-20 h-20 rounded-2xl bg-gradient-to-br from-gray-100 to-gray-50 dark:from-white/10 dark:to-white/5 flex items-center justify-center mb-5 shadow-inner">
              <svg class="w-10 h-10 text-gray-300 dark:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
              </svg>
            </div>
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">No Data Found</h3>
            <p class="text-sm text-gray-500 dark:text-gray-400 text-center max-w-md">
              No details are available for this question.
            </p>
          </div>
        </div>
        
      </div>

    </div>
  </main>

  <!-- Detail Modal -->
  <div *ngIf="selectedItem" 
       class="fixed inset-0 z-[100] bg-black/70 backdrop-blur-md flex items-center justify-center p-6"
       (click)="closeDetailModal()">
    <div class="relative bg-white dark:bg-[#111111] rounded-2xl shadow-2xl max-w-5xl w-full max-h-[85vh] overflow-hidden border border-gray-100 dark:border-white/10" 
         (click)="$event.stopPropagation()">
      
      <!-- Close Button -->
      <button (click)="closeDetailModal()" 
              class="absolute top-5 right-5 z-10 w-9 h-9 rounded-full bg-black/5 dark:bg-white/10 hover:bg-black/10 dark:hover:bg-white/20 flex items-center justify-center text-gray-500 dark:text-gray-400 transition-all duration-200 hover:rotate-90">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>

      <div class="flex flex-col md:flex-row h-full">
        <!-- Left Side - Information -->
        <div class="w-full md:w-[45%] p-6 overflow-y-auto max-h-[85vh]">
          
          <!-- Question Card -->
          <div class="bg-gradient-to-br from-indigo-50 to-violet-50 dark:from-indigo-500/10 dark:to-violet-500/10 rounded-xl p-4 mb-4 border border-indigo-100/50 dark:border-indigo-500/20">
            <div class="flex items-center gap-2 mb-2">
              <div class="w-6 h-6 rounded-lg bg-indigo-500 flex items-center justify-center">
                <svg class="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
                </svg>
              </div>
              <span class="text-[10px] font-bold text-indigo-600 dark:text-indigo-400 uppercase tracking-wider">Question</span>
              <span class="text-[10px] font-mono text-indigo-500/60 dark:text-indigo-400/60">Q{{ questionId }}</span>
            </div>
            <p class="text-sm font-medium text-gray-800 dark:text-gray-200 leading-relaxed">{{ questionName }}</p>
          </div>

          <!-- Prompt Card -->
          <div *ngIf="questionPrompts && questionPrompts.length > 0" class="bg-gradient-to-br from-violet-50 to-purple-50 dark:from-violet-500/10 dark:to-purple-500/10 rounded-xl p-4 mb-4 border border-violet-100/50 dark:border-violet-500/20">
            <div class="flex items-center gap-2 mb-2">
              <div class="w-6 h-6 rounded-lg bg-violet-500 flex items-center justify-center">
                <svg class="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
                </svg>
              </div>
              <span class="text-[10px] font-bold text-violet-600 dark:text-violet-400 uppercase tracking-wider">Prompt</span>
            </div>
            <div *ngFor="let prompt of questionPrompts">
              <p class="text-sm text-violet-700 dark:text-violet-300 leading-relaxed">{{ prompt }}</p>
            </div>
          </div>

          <!-- Location Card -->
          <div class="bg-gradient-to-br from-slate-50 to-gray-50 dark:from-slate-500/10 dark:to-gray-500/10 rounded-xl p-4 mb-4 border border-slate-100/50 dark:border-slate-500/20">
            <div class="flex items-center gap-2 mb-3">
              <div class="w-6 h-6 rounded-lg bg-slate-600 dark:bg-slate-500 flex items-center justify-center">
                <svg class="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
                </svg>
              </div>
              <span class="text-[10px] font-bold text-slate-600 dark:text-slate-400 uppercase tracking-wider">Location</span>
            </div>
            <p class="text-base font-semibold text-gray-900 dark:text-white mb-3">{{ selectedItem.location }}</p>
            <div class="flex flex-wrap gap-2">
              <span class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white dark:bg-black/20 text-xs font-medium text-gray-600 dark:text-gray-300 border border-gray-200 dark:border-white/10">
                <span class="text-gray-400 dark:text-gray-500">Instance:</span>
                <span class="font-mono">{{ selectedItem.instanceId }}</span>
              </span>
              <span class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white dark:bg-black/20 text-xs font-medium text-gray-600 dark:text-gray-300 border border-gray-200 dark:border-white/10">
                <span class="text-gray-400 dark:text-gray-500">Location:</span>
                <span class="font-mono">{{ selectedItem.locationId }}</span>
              </span>
            </div>
          </div>

          <!-- Status Cards Row -->
          <div class="grid grid-cols-2 gap-3 mb-4">
            <!-- Quality Card -->
            <div class="rounded-xl p-4 border"
                 [ngClass]="selectedItem.meetsQualityStandards 
                   ? 'bg-gradient-to-br from-emerald-50 to-green-50 dark:from-emerald-500/10 dark:to-green-500/10 border-emerald-100 dark:border-emerald-500/20' 
                   : 'bg-gradient-to-br from-red-50 to-rose-50 dark:from-red-500/10 dark:to-rose-500/10 border-red-100 dark:border-red-500/20'">
              <div class="flex items-center gap-2 mb-2">
                <div class="w-6 h-6 rounded-lg flex items-center justify-center"
                     [ngClass]="selectedItem.meetsQualityStandards ? 'bg-emerald-500' : 'bg-red-500'">
                  <svg *ngIf="selectedItem.meetsQualityStandards" class="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                  </svg>
                  <svg *ngIf="!selectedItem.meetsQualityStandards" class="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                  </svg>
                </div>
                <span class="text-[10px] font-bold uppercase tracking-wider"
                      [ngClass]="selectedItem.meetsQualityStandards ? 'text-emerald-600 dark:text-emerald-400' : 'text-red-600 dark:text-red-400'">Quality</span>
              </div>
              <p class="text-lg font-bold"
                 [ngClass]="selectedItem.meetsQualityStandards ? 'text-emerald-600 dark:text-emerald-400' : 'text-red-600 dark:text-red-400'">
                {{ selectedItem.meetsQualityStandards ? 'Pass' : 'Fail' }}
              </p>
            </div>

            <!-- Confidence Card -->
            <div class="rounded-xl p-4 border"
                 [ngClass]="{
                   'bg-gradient-to-br from-emerald-50 to-green-50 dark:from-emerald-500/10 dark:to-green-500/10 border-emerald-100 dark:border-emerald-500/20': selectedItem.score >= 3,
                   'bg-gradient-to-br from-amber-50 to-orange-50 dark:from-amber-500/10 dark:to-orange-500/10 border-amber-100 dark:border-amber-500/20': selectedItem.score >= 2 && selectedItem.score < 3,
                   'bg-gradient-to-br from-red-50 to-rose-50 dark:from-red-500/10 dark:to-rose-500/10 border-red-100 dark:border-red-500/20': selectedItem.score < 2
                 }">
              <div class="flex items-center gap-2 mb-2">
                <div class="w-6 h-6 rounded-lg flex items-center justify-center"
                     [ngClass]="{
                       'bg-emerald-500': selectedItem.score >= 3,
                       'bg-amber-500': selectedItem.score >= 2 && selectedItem.score < 3,
                       'bg-red-500': selectedItem.score < 2
                     }">
                  <svg class="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z" />
                  </svg>
                </div>
                <span class="text-[10px] font-bold uppercase tracking-wider"
                      [style.color]="getItemScoreColor(selectedItem.score)">Confidence</span>
              </div>
              <p class="text-lg font-bold" [style.color]="getItemScoreColor(selectedItem.score)">
                {{ getItemConfidenceLabel(selectedItem.score) }}
              </p>
            </div>
          </div>

          <!-- Analysis Card -->
          <div class="bg-gradient-to-br from-blue-50 to-cyan-50 dark:from-blue-500/10 dark:to-cyan-500/10 rounded-xl p-4 border border-blue-100/50 dark:border-blue-500/20">
            <div class="flex items-center gap-2 mb-2">
              <div class="w-6 h-6 rounded-lg bg-blue-500 flex items-center justify-center">
                <svg class="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                </svg>
              </div>
              <span class="text-[10px] font-bold text-blue-600 dark:text-blue-400 uppercase tracking-wider">Analysis</span>
            </div>
            <p class="text-sm text-blue-800 dark:text-blue-200 leading-relaxed">{{ selectedItem.analysis }}</p>
          </div>
        </div>

        <!-- Right Side - Image -->
        <div class="w-full md:w-[55%] bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 p-6 flex items-center justify-center min-h-[300px] md:min-h-full">
          <div *ngIf="selectedItem.imageUrl" class="w-full h-full flex items-center justify-center relative group">
            <img [src]="detailImageSrc"
                 alt="Location Image"
                 class="max-w-full max-h-[70vh] object-contain rounded-xl shadow-2xl cursor-pointer transition-all duration-300 hover:shadow-3xl"
                 (click)="viewImage(selectedItem.imageUrl)"
                 (error)="onDetailImageError()">
            <!-- Click to expand hint -->
            <div class="absolute bottom-4 left-1/2 -translate-x-1/2 px-4 py-2 rounded-full bg-black/60 backdrop-blur-sm text-white text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-2">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607zM10.5 7.5v6m3-3h-6" />
              </svg>
              Click to expand
            </div>
          </div>
          <div *ngIf="!selectedItem.imageUrl" class="text-center">
            <div class="w-24 h-24 rounded-2xl bg-gray-300 dark:bg-white/10 flex items-center justify-center mx-auto mb-4">
              <svg class="w-12 h-12 text-gray-400 dark:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
              </svg>
            </div>
            <p class="text-gray-500 dark:text-gray-400 font-medium">No image available</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Image Modal - Full Screen -->
  <div *ngIf="selectedImageUrl" 
       class="fixed inset-0 z-[110] bg-black/95 flex items-center justify-center"
       (click)="closeImageModal()">
    <div class="relative w-full h-full flex items-center justify-center p-4" (click)="$event.stopPropagation()">
      <!-- Close Button -->
      <button (click)="closeImageModal()" 
              class="absolute top-4 right-4 z-10 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 backdrop-blur-sm flex items-center justify-center text-white transition-all duration-200 hover:scale-110">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>
      <!-- ESC hint -->
      <span class="absolute top-6 left-6 text-white/50 text-sm">Press ESC or click anywhere to close</span>
      <!-- Image -->
      <img [src]="fullImageSrc" alt="Detail Image" class="max-w-[95vw] max-h-[95vh] object-contain rounded-lg shadow-2xl" (error)="onFullImageError()">
    </div>
  </div>

</div>
